import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Tie } from '../../_shared/models/tie.model';

@Component({
  selector: 'app-int-team-name',
  templateUrl: './int-team-name.component.html',
  styleUrls: ['./int-team-name.component.scss'],
  standalone: true,
  imports:[CommonModule]
})
export class IntTeamNameComponent  implements OnInit {
    @Input({ required: true }) rowHeight: any;
    @Input({ required: true }) isReverse: any;
    @Input({ required: true }) sideColors: any;
    @Input({ required: true }) sideName: any;
    @Input({ required: true }) sideNumber: number;
    @Input({ required: true }) tie: Tie;
  constructor() { }

  ngOnInit() {}

  getTeam(sideNumber: number) {
    return this.tie?.sides[sideNumber - 1].team;
  }

}
